import {Injectable} from '@angular/core';
import {IApi, IPageAndSort} from '@entities/api';
import {IListSubject, ISyncStatusProgress} from '@entities/subject';
import {ApiService} from '@shared/services';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchApi extends ApiService {
  public getSubjects(payload: {
    query: string;
    pagination?: IPageAndSort;
  }): Observable<IApi<IListSubject[] | ISyncStatusProgress>> {
    return this.get<IApi<IListSubject[] | ISyncStatusProgress>>(
      `${this.apiUrl}/subjects/search`,
      {params: this.buildSearchParams(payload.query, payload.pagination)}
    );
  }

  public getSubjectsCheck(payload: {
    query: string;
    pagination?: IPageAndSort;
  }): Observable<ISyncStatusProgress> {
    return this.get<ISyncStatusProgress>(
      `${this.apiUrl}/subjects/search/check`,
      {params: this.buildSearchParams(payload.query, payload.pagination)}
    );
  }

  private buildSearchParams(
    query: string,
    pagination?: IPageAndSort
  ): Record<string, string | number> {
    const params: Record<string, string | number> = {query};
    if (pagination) {
      params['page[size]'] = 15;
      params['page[number]'] = pagination.page;
    }
    return params;
  }
}
